import axios from 'axios'

export default {
    getCurrentUser(hasAuth, noAuth){
       return axios.get('/login/check').then((req)=>{
            hasAuth(req.data.user);
        }).catch((req)=>{
            noAuth(req);
        })
    },

    logout(onDone, onError){
        axios.post('/logout',{
            headers: {'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content}
        }).then((req)=>{
            onDone(req.data);
        }).catch((req)=>{
            onError(req);
        })
    },

    getFullData(onDone, onError){
        return axios.get('/user_data').then((req)=>{
            onDone(req.data);
        }).catch((req)=>{
            onError(req);
        })
    }
}
